export default __webpack_public_path__ + "static/media/bg-login.f21d8566.svg";